import { useQuery } from "react-query";
import minigridAPI from "../../service/minigridAPI";
import { MinigridLiveSnapshot } from "../../types/minigridtypes";

const POLL_INTERVAL_MS = 10000;

export interface UseLiveSnapshotConfig {
    minigridId: string;
}

export interface UseLiveSnapshotResult {
    snapshot: MinigridLiveSnapshot | null;
    isInitialLoading: boolean;
    error: string | null;
}

/**
 * useLiveSnapshotCore
 *
 * Polls the backend /minigrids/{id}/live endpoint every 10s via react-query.
 * react-query handles StrictMode dedup, refetch-on-focus, cancellation, and
 * cleanup — no manual setInterval / AbortController plumbing needed.
 */
export default function useLiveSnapshotCore(
    config: UseLiveSnapshotConfig
): UseLiveSnapshotResult {
    const liveQuery = useQuery({
        queryKey: ["minigrid", config.minigridId, "live"],
        queryFn: () => minigridAPI.getMinigridLive(config.minigridId),
        enabled: config.minigridId !== "",
        refetchInterval: POLL_INTERVAL_MS,
        refetchIntervalInBackground: false,
    });

    return {
        snapshot: liveQuery.data ?? null,
        isInitialLoading: liveQuery.isLoading,
        error: liveQuery.isError
            ? "Impossible de récupérer les données en direct"
            : null,
    };
}
